module.exports = __webpack_public_path__ + "img/4.ebff4456.png";